export const ROLE_SIMPLES = "ROLE_SIMPLES";
export const ROLE_GESTOR = "ROLE_GESTOR";
export const ROLE_ADMINISTRADOR = "ROLE_ADMINISTRADOR";
export const ROLE_EMAIL = "ROLE_EMAIL";
export const ROLE_SMS = "ROLE_SMS";
export const ROLE_CARIMBO_TEMPO_EMAIL = "ROLE_CARIMBO_TEMPO_EMAIL";
export const ROLE_CARIMBO_TEMPO_SMS = "ROLE_CARIMBO_TEMPO_SMS";
export const ROLE_ENVIO_MASSA_CARIMBO_TEMPO = "ROLE_ENVIO_MASSA_CARIMBO_TEMPO";
export const ROLE_FEATURE_1 = "ROLE_FEATURE_1";
export const ROLE_FEATURE_2 = "ROLE_FEATURE_2";
export const ROLE_FEATURE_3 = "ROLE_FEATURE_3";
export const ROLE_COLUNA_INSTALACAO_RELATORIO_CAMPANHA = "ROLE_COLUNA_INSTALACAO_RELATORIO_CAMPANHA";
export const ROLE_COLUNA_PROTOCOLO_RELATORIO_CAMPANHA = "ROLE_COLUNA_PROTOCOLO_RELATORIO_CAMPANHA";
export const ROLE_LAUDO_LOTE = "ROLE_LAUDO_LOTE";
export const ROLE_ENVIO_UNICO_CARIMBO_TEMPO = "ROLE_ENVIO_UNICO_CARIMBO_TEMPO";